module.exports = __webpack_public_path__ + "static/media/dev-11.2c92ac38.png";